import React from 'react'
import { connect } from 'react-redux'
import USAMap from 'react-usa-map'
import { Link } from 'react-router-dom'

import { FeatureBottom } from './features/FeatureBottom'
import { PowerSchoolAquisition } from './PowerSchoolAquisition'

import { listDeployments } from '../actions/tenantFinder'

//"return validateSubmit(this)
class HomePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      hovered: null,
      searchTerm: ''
    }
  }

  componentDidMount() {
    this.props.dispatch(listDeployments())
  }

  handleSearchTermChange = e => {
    return this.setState({ ...this.state, searchTerm: e.target.value })
  }

  stateConfig = () => {
    const sl = this.state.selected
    const cfg = this.props.stateData.result.reduce((config, st) => {
      let fill = '#aaa'

      if (st.regionId === sl) {
        fill = '#93ca3b'
      }

      if (st.regionId === this.state.hovered) {
        fill = '#55ad66'
      }

      return {
        ...config,
        [st.regionId]: { fill }
      }
    }, {})

    return cfg
  }

  handleMapClick = s => {
    this.setState({
      selected: s.target.dataset.name
    })
  }

  handleMapHover = s => {
    console.log(s.target.dataset.name)
  }

  handleStateClick = s => {
    console.log('REGION ID', s, this.state)
    this.setState({
      ...this.state,
      hovered: null,
      selected: s,
      searchTerm: ''
    })
  }

  handleStateHover = s => {
    this.setState({
      ...this.state,
      hovered: s
    })
  }

  filterStates = states => {
    if (!this.state.searchTerm?.length) {
      return null
    }

    // console.log(states)
    const filtered =
      states
        ?.filter(s => {
          const lcName = s.regionName.toLowerCase()
          const st = this.state.searchTerm.toLowerCase()
          const additional =
            s.regionId == 'DC' &&
            ('washington, d.c.'.includes(st) || 'washington, dc'.includes(st))

          return additional || lcName.includes(st)
        })
        .slice(0, 5) ?? []

    // console.log(this.state.searchTerm.toLowerCase(), filtered)
    return (
      <div className="state-drop-down">
        <ul>
          {filtered.map(c => (
            <li key={c.url} onClick={() => this.handleStateClick(c.regionId)}>
              <div className="col-xs-5 col-sm-3">
                <img style={{ maxHeight: '30px' }} src={c.logoJPG} />
              </div>
              <div className="col-xs-7 col-sm-9">
                <h4 className="pull-left" style={{ lineHeight: '30px' }}>
                  {c.name}
                </h4>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  renderMiddleContent = () => {
    /** TODO: update marketingUrl */
    const selectedState = this.props.stateData?.result?.find(
      s => s.regionId == this.state.selected
    )
    //console.log(this.props.stateData, this.state.selected, selectedState)

    return (
      <div className="section">
        <button
          style={{ marginBottom: '25px' }}
          onClick={() => this.handleStateClick(null)}
          className="btn btn-danger pull-right">
          X
        </button>
        <img src={selectedState?.logo} alt={`${selectedState?.regionId} State Logo`} />
        <a href={selectedState?.defaultURL} className="btn btn-success btn-full">
          Get Started
        </a>
        <Link to={`/${selectedState?.id}`} className="btn btn-info btn-full">
          Find out More
        </Link>
      </div>
    )
  }

  render() {
    if (!this.props.stateData.result) {
      return <div></div>
    }

    const sortedStates = [...this.props.stateData?.result]?.sort((a, b) =>
      a.regionId?.localeCompare(b.regionId)
    )

    //console.log(sortedStates, this.props.stateData.result)
    return (
      <div
        className="homepage"
        role="button"
        onClick={() => {
          if (this.state.searchTerm) {
            this.setState({ ...this.state, searchTerm: '' })
          }
        }}>
        <PowerSchoolAquisition />
        <div className="container">
          <h2>The CareerExplorer is designed for your state</h2>
          <p>
            Students, educators, jobseekers, and others can access up-to-date information
            on wages, job openings, and other information specific to your state along
            with great information on careers, colleges, and more. And, if you signed up
            for an account on any of our sites, you already have access to all of them!
          </p>
        </div>
        <div
          className="title-block-bar"
          style={{ backgroundColor: '#f2f7e7', overflow: 'hidden' }}>
          <div className="container">
            <h3>Get started by selecting your state</h3>
            <div className="search-wrap" onClick={e => e.stopPropagation()}>
              <input
                className="input-lg form-control text-input"
                placeholder="Type your state or select from the list or map below"
                value={this.state.searchTerm}
                onChange={this.handleSearchTermChange}
              />
              {this.filterStates(sortedStates)}
            </div>

            <div className="row sliding-sections" style={{ minHeight: '400px' }}>
              <div
                className={`hidden-xs col-sm-6 slide-left home-map ${
                  this.state.selected ? 'slid-open' : ''
                }`}>
                <USAMap
                  onClick={this.handleMapClick}
                  onMouseOver={this.handleMapHover}
                  onMouseOut={this.handleMapHover}
                  customize={this.stateConfig()}
                  width={600}
                  height={375}
                />
              </div>
              <div
                className={`col-xs-12 col-sm-6 slide-appear ${
                  this.state.selected ? '' : 'notvisible'
                }`}>
                {this.renderMiddleContent()}
              </div>
              <div
                className={`col-xs-12 col-sm-6 slide-right ${
                  this.state.selected ? 'slid-open' : ''
                }`}>
                {sortedStates.map(s => {
                  return (
                    <div
                      style={{ width: '9%', padding: '5px', float: 'left' }}
                      key={s.regionId}
                      className="text-center">
                      <a
                        onClick={() => this.handleStateClick(s.regionId)}
                        onMouseOver={() => this.handleStateHover(s.regionId)}
                        onMouseOut={() => this.handleStateHover(null)}
                        title={s.regionName}
                        className="state-link"
                        style={{ fontSize: '.8rem' }}>
                        <img src={s.thumb} alt={`Logo for ${s.id}`} /> {s.regionId}
                      </a>
                    </div>
                  )
                })}
              </div>
            </div>
            <br className="clear" />
          </div>
        </div>
        <FeatureBottom />
        <div
          className="row section feature-contact-section"
          style={{ paddingTop: '50px', paddingBottom: '50px' }}>
          <div
            className="title-block-bar"
            style={{
              backgroundColor: '#EEE',
              paddingTop: '60px',
              paddingBottom: '60px'
            }}>
            <div className="container">
              <div className="col-sm-12">
                <h3 style={{ marginBottom: '25px' }}>
                  About <b>Headed2</b> and the <b>CareerExplorer</b>
                </h3>
                <p style={{ color: 'black' }}>
                  For over 15 years, Headed2 has been helping students plan for their
                  future and explore the world of work. In that time, we have grown into a
                  reliable and robust platform that services millions of individuals each
                  year from across the United States.
                </p>
                <Link to={`/about`} className="btn btn-success btn-lg pull-right">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      stateData: state.tenantFinder.data,
      completionData: state.tenantFinder.search
    }
  },
  dispatch => {
    return { dispatch }
  }
)(HomePage)
